<template>
    <v-dialog
        v-model="activate"
        max-width="900px"
        persistent
    >
        <v-card class="px-4" color="background">
            <v-card-title>
            <vuse-section-definition
                :title="formTitle"
                icon="mdi-account-supervisor"
                class="ml-n4 pa-0 pb-4" />
            </v-card-title>
            <v-card-text>
                <v-container class="mb-2 pa-0">
                    <v-form ref="userForm">
                    <v-sheet class="neu-glow px-6">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.userLogin"
                                    @input="validate"
                                    :label="$t('Global.Users.userLogin')+'*'"
                                    :rules="[ requiredRule ]"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.firstName"
                                    @input="validate"
                                    :label="$t('Global.Users.firstName')+'*'"
                                    :rules="[ requiredRule ]"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.lastName"
                                    @input="validate"
                                    :label="$t('Global.Users.lastName')+'*'"
                                    :rules="[ requiredRule ]"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.email"
                                    @input="validate"
                                    :label="$t('Global.Users.email')+'*'"
                                    :rules="[ requiredRule, validEmail ]"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                  v-model="editedItem.roleId"
                                  :items="getRolesEnableds"
                                  @change="validate"
                                  item-text="roleName"
                                  item-value="roleId"
                                  :label="$t('Global.Users.role')+'*'"
                                  :rules="[ requiredRule ]"
                                  required
                                  :menu-props="{ bottom: false, offsetY: true }" />
                            </v-col>
                            <v-col cols="12" md="4" v-if="editedItem.roleId!==2">
                                <v-combobox
                                  v-model="editedItem.queues"
                                  :items="queueList"
                                  @change="validate"
                                  item-text="nodeName"
                                  item-value="nodeId"
                                  :label="$t('Global.Users.queues')"
                                  return-object
                                  multiple
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </v-sheet>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('Global.Nodes.cancel') }}</v-btn>
            <v-btn color="blue darken-1" text @click="submitItem" :disabled="!validForm">{{ $t('Global.Nodes.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Utils from "@/mixins/Utils";
import {mapGetters} from "vuex";
import ROL from "@/config/rol-values";
import NodeApi from "@/mixins/Services/NodeApi";

export default {
    name: "NodesDialog",
    mixins: [Utils, NodeApi],
    props: {
        activate: {
            type: Boolean,
            default: false,
            required: true
        },
        isViewSuper: {
            type: Boolean,
            default: false,
            required: true
        },
        item: {
            type: Object,
            default: null
        }
    },
  data() {
    return {
      editedItem: {
        userLogin: "",
        firstName: "",
        lastName: "",
        email: "",
        roleId: "",
        companyId: "",
        queues: []
      },
      defaultItem: {
        userLogin: "",
        firstName: "",
        lastName: "",
        email: "",
        roleId: "",
        companyId: "",
        queues: []
      },
      queueList: [],

      requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
      validEmail: v => v == null || v === "" || !!v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/) ? true : this.$t('Global.FormRules.invalidFormat'),
      validForm: false,
      rol: ROL,
    }
  },
    computed: {
      ...mapGetters(['getDefsRolesTypes', 'getRoleId']),
        formTitle() {
            return !this.item ? this.$t('Global.Users.newUser') : this.$t('Global.Users.editUser');
        },
      isRolSuper(){
        return [this.rol.SUPER_ADMIN, this.rol.SUPER_USER].includes(this.getRoleId)
      },
      getRolesEnableds(){
        return this.getDefsRolesTypes
            .filter((f)=> this.isRolSuper && this.isViewSuper
                ? [this.rol.SUPER_ADMIN, this.rol.SUPER_USER].includes(f.roleId)
                : [this.rol.SITE_ADMIN, this.rol.SITE_USER, this.rol.DISPLAY_USER].includes(f.roleId) )
      }
    },
    methods: {
        validate() {
            this.validForm = this.$refs.userForm.validate()
        },
        closeDialog() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.$emit('close-dialog')
        },
        submitItem() {
            for (const prop in this.editedItem ) {
                if (this.editedItem[prop] === null) this.editedItem[prop] = ""
            }
            if (this.item)
                this.$emit('update-item', this.editedItem)
            else
                this.$emit('create-item', this.editedItem)
            this.closeDialog()
        },
      getRoleType(item) {
        return this.getDefsRolesTypes.find((e) => e.roleId === item.roleId)?.roleName
      },
      async getQueuesList() {
      try{
        this.setLoader(true)
          this.queueList = await this.getQueuesByCompany();
        this.setLoader(false)
        } catch (e) {
          this.queueList = []
          console.error('[USERS][getQueuesList] ERROR:', e)
          this.setLoader(false)
          if(this.isErrorText(e)){
            const errorCode = this.getErrorText(e);
            this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
          }
        }
      }
    },
    mounted(){
      this.getQueuesList()
      if (this.item) {
        this.editedItem = Object.assign({}, this.item)
      } else {
        this.defaultItem['companyId'] = this.loadCompanyId()
        this.editedItem = Object.assign({}, this.defaultItem)
      }
    }
}
</script>

